export const CONSTANTS = [1, 2, 3];

export const LOAD_MORE = 30;
